import { ResultStatus } from '../enum/resultstatus';
import { CheckResult, Document } from '.';
export class CheckResults {
  overallStatus: ResultStatus;
  overallMessage: string;
  resultsList: Array<CheckResult>;
  documents: Array<Document>;
  resultsValidityDate: Date;
}
